import type { IRatingMatrixFrameworkGradeScore, IRatingMatrixFrameworkOption } from '__generated__';

export function buildOptionFilter(subParameterId: number): string {
  return `subParameterID==${subParameterId}`;
}

/** Batch filter for prefetch — one GetAllDynamic for many qualitative rows. */
export function buildOptionsForSubsFilter(subParameterIds: number[]): string | null {
  if (subParameterIds.length === 0) {
    return null;
  }
  if (subParameterIds.length === 1) {
    return buildOptionFilter(subParameterIds[0]);
  }
  return `(${subParameterIds.map((id) => `subParameterID==${id}`).join('||')})`;
}

export type OptionRow = {
  gradeScoreId: number;
  gradeLabel: string;
  numericScore: number;
  optionId: number | null;
  description: string;
};

export function buildOptionRows(
  grades: IRatingMatrixFrameworkGradeScore[],
  existingOptions: IRatingMatrixFrameworkOption[],
): OptionRow[] {
  const optionsByGrade = new Map<number, IRatingMatrixFrameworkOption>();

  existingOptions.forEach((option) => {
    optionsByGrade.set(option.gradeScoreID, option);
  });

  return [...grades]
    .sort((left, right) => left.numericScore - right.numericScore)
    .map((grade) => {
      const existing = optionsByGrade.get(grade.id);

      return {
        gradeScoreId: grade.id,
        gradeLabel: grade.gradeLabel ?? '',
        numericScore: grade.numericScore,
        optionId: existing?.id ?? null,
        description: existing?.description ?? '',
      };
    });
}

export function buildOptionSaveBulkPayload(
  subParameterId: number,
  rows: OptionRow[],
): Partial<IRatingMatrixFrameworkOption>[] {
  return rows.map((row) => ({
    id: row.optionId ?? undefined,
    subParameterID: subParameterId,
    gradeScoreID: row.gradeScoreId,
    description: row.description || null,
  }));
}
